import Vue from 'vue'
import md5 from 'md5'
import Vuex from 'vuex'
import * as actions from './actions'
import * as types from './mutation-types'

// modules
import isp from './modules/isp'
import user from './modules/user'

Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

// Random Device UUID
const UUID_STORAGE_KEY = 'uuid.ytv'
var uuid = localStorage.getItem(UUID_STORAGE_KEY)
if (uuid == null) {
    uuid = md5('xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random()*16|0, v = c == 'x' ? r : (r&0x3|0x8)
        return v.toString(16)
    }))
    localStorage.setItem(UUID_STORAGE_KEY, uuid)
}

const state = {
  appReady: false,
  uuid,
}

// getters
const getters = {
}

// Create an object storing various mutations. We will write the mutation
const mutations = {

  [types.APP_STATE] (state, ready) {
    state.appReady = ready
  },

}

export default new Vuex.Store({
  state,
  actions,
  mutations,
  modules: {
    isp,
    user
  },
  strict: debug
})